import { render, staticRenderFns } from "./recusManager.vue?vue&type=template&id=9d223d8e&"
import script from "./recusManager.vue?vue&type=script&lang=ts&"
export * from "./recusManager.vue?vue&type=script&lang=ts&"
import style0 from "./recusManager.vue?vue&type=style&index=0&id=9d223d8e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports